// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invResourceId } from './InvResource';
import { invRecipeCategoryId } from './InvRecipeCategory';
import { invWaterKindEnum } from './InvWaterKindEnum';
import { z } from 'zod';
export const invRecipeId = (z.number());
export const invRecipe = z.object({
    id: invRecipeId,
    name: z.string(),
    version: z.string(),
    produces_resource_id: invResourceId,
    category_id: invRecipeCategoryId.nullable(),
    water_type: invWaterKindEnum.nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const invRecipeInitializer = z.object({
    id: invRecipeId.optional(),
    name: z.string(),
    version: z.string(),
    produces_resource_id: invResourceId,
    category_id: invRecipeCategoryId.optional().nullable(),
    water_type: invWaterKindEnum.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const invRecipeMutator = z.object({
    id: invRecipeId.optional(),
    name: z.string().optional(),
    version: z.string().optional(),
    produces_resource_id: invResourceId.optional(),
    category_id: invRecipeCategoryId.optional().nullable(),
    water_type: invWaterKindEnum.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=InvRecipe.js.map